module.exports = __webpack_public_path__ + "img/play.00fdd7ee.svg";